import { KeyValue } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AlertsService } from '../alerts-custom.service';
import { AlertsvarService, FactsheetEventsPanel, FactsheetSummaryPanel } from '../alertsvar.service';
import { MatDialog } from '@angular/material/dialog';
import { AssignUserComponent } from '../template/assign-user/assign-user.component';
import { SettingsService } from 'src/app/settings/settings.service';
import { AddNotesComponent } from '../template/add-notes/add-notes.component';
import { UpdateActionComponent } from '../template/update-action/update-action.component';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { AdvanceFilterComponent } from '../template/advance-filter/advance-filter.component';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { RelationChartComponent } from '../relation-chart/relation-chart.component';
import { AdditionalEventsComponent } from '../template/additional-events/additional-events.component'
import * as echarts from "echarts";
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { ShowPopupEventsComponent } from '../template/show-popup-events/show-popup-events.component';
import { ValueValidator } from 'src/app/designer/validator/fieldValueValidator';
import { SharedService } from 'src/app/services/shared.service';
import { ExploreAlertActionPanelComponent } from 'src/app/shared/explore-alerts-action-panel/explore-alerts-action-panel';

@Component({
  selector: 'app-fact-sheet',
  templateUrl: './fact-sheet.component.html',
  styleUrls: ['./fact-sheet.component.scss']
})
export class FactSheetComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedEvent: string = '';
  cancel_filter_state: boolean = false
  additionalEventsSpinnerState: boolean = false;
  AlertEventsCount: any = 0;
  notesList = ["Severity low", "Severity medium", "Severity high"]
  @ViewChild('addNotesTemplate') addNotesTemplate: ElementRef
  addNotesRef;
  entityFieldsRef;
  chartOption = {
    tooltip: {
      trigger: 'item'
    },
    dataZoom: {
      start: 0,
      type: "inside"
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    grid: {
      "left": "2%",
      "right": "2%",
      "bottom": "5%",
      "top": "10%",
      "containLabel": true
    },
    series: [
      {
        data: [],
        type: 'bar'
      }
    ]
  };
  myChart;

  insightAlertsheader = ["Metric", "In Duration", "Till Date", "%"]
  insightEpisodeDetailsheader = ["Metric", "Time Range", "Alerts", "%"]
  insightAlertCountheader = ["Time Period", "Alerts", "%"]
  insightDetails = {
    "Inspection Details": {
      "Start Time": 1739856957,
      "End Time": 1739856957,
      "Duration": "1 day"
    },
    "Episode Insight": {
      "Episode Length": "10 minutes",
      "Episodes Without Alerts / Total Episodes": "72 of 144 (50%)",
      "Avg. Alerts per Episode": 5000 / 100,
      "table_content": [
        {
          "metric": "Episode with Highest Alerts",
          "time_tange": "2025 Feb 17 09:20 - 09:30",
          "alerts_count": "1000",
          "percentage": "10"
        },
        {
          "metric": "Episode with Lowest Alerts",
          "time_tange": "2025 Feb 17 10:20 - 10:30",
          "alerts_count": "100",
          "percentage": "1"
        }
      ],

    },
    "Alert Insights": [
      {
        "metric": "Total Alerts(This Rule)",
        "current_inspection_duration": "10",
        "till_date": "10,000",
        "total_percentage": "10",

      },
      {
        "metric": "Total Alerts(Chosen Platform)",
        "current_inspection_duration": "100",
        "till_date": "1,00,000",
        "total_percentage": "11",

      },
      {
        "metric": "Total Alerts(All Platforms)",
        "current_inspection_duration": "1,000",
        "till_date": "1,000,000",
        "total_percentage": "15",
      }
    ],
    // "Example Interpretation": '"For the current inspection duration, this rule accounts for 5% of all alerts, while historically ,it has accounted for 10% of all alerts till date"',
    "Source & Field Details": {
      "Active Sources / Total Sources": "1 of 2",
      "Field Coverage": 0
    },
    "Alert Count by Time Period": [{ "period": "Morning Start (7:00 AM - 9:00 AM)", "count": "0", "percentage": "0" },
    { "period": "Mid-Morning (9:00 AM - 12:00 PM)", "count": "0", "percentage": "0" },
    { "period": "Early Afternoon (12:00 PM - 2:00 PM)", "count": "0", "percentage": "0" },
    { "period": "Late Afternoon (2:00 PM - 6:00 PM)", "count": "0", "percentage": "0" },
    { "period": "Evening (6:00 PM - 9:00 PM)", "count": "0", "percentage": "0" },
    { "period": "Night (9:00 PM - 12:00 AM)", "count": "0", "percentage": "0" },
    { "period": "Late Night (12:00 AM - 3:00 AM)", "count": "0", "percentage": "0" },
    { "period": "Pre-Dawn (3:00 AM - 6:00 AM)", "count": "0", "percentage": "0" },
    { "period": "Early Morning (6:00 AM - 7:00 AM)", "count": "0", "percentage": "0" }]

  }
  alertStatus = [];

  // alertActionMetadata: any = {
  //   "defaultActionStatus": "flagged_for_review",
  //   "defaultActionState": "True positive",
  //   "actions": {
  //     "flagged_for_review": {
  //       "disp": "Flagged for review",
  //       "state_action": {
  //         "True positive": [
  //           "Malware Infection",
  //           "Successful Exploit",
  //           "Intrusion attempt",
  //           "Account Compromise",
  //           "Compliance violation"
  //         ]
  //       }
  //     },
  //     "close": {
  //       "disp": "Close",
  //       "state_action": {
  //         "Benign true positive": [
  //           "Red Team",
  //           "Expected Activity",
  //           "Authorized Activity",
  //           "Threat Mitigated Automatically",
  //           "Potentially Unwanted Program (PUP)",
  //           "Maintenance",
  //           "System errors"
  //         ],
  //         "False positive": [
  //           "Not Vulnerable",
  //           "Informational"
  //         ],
  //         "Undetermined": [
  //           "Duplicate",
  //           "Incorrect alert logic"
  //         ]
  //       }
  //     }
  //   },
  //   "errors": {
  //     "actionstate": "Selected one state",
  //     "reason": "Selected one reason"
  //   },
  //   "action_disp": {
  //     "Flagged for review": "Review",
  //     "Close": "Close",
  //     "open": "Open",
  //     "True positive": "TP",
  //     "Benign true positive": "B-TP",
  //     "False positive": "FP",
  //     "Undetermined": "UD",
  //     "-": "-"
  //   }

  // }


  constructor(
    public alertService: AlertsService,
    public alertvarservice: AlertsvarService,
    private matdialog: MatDialog,
    private settingsService: SettingsService,
    private cdkoverlayDialog: CdkOverlyayService,
    private timezoneservice: TimeZoneService,
    private sharedservice: SharedService
  ) { }
  alertActionMetadata: any = this.alertvarservice.updateActionMetadata
  //destroy
  $destroy: Subject<boolean> = new Subject();

  factsheetMeta: any = this.alertvarservice.alertsheetmeta.factsheetMeta;
  isAction: boolean = this.alertvarservice.alertactionmanagement.procressProgress();
  assigUserSpinnerState: boolean = false;
  //dialogRef
  overLayRef: any
  HistoricalAnalysis = true
  //rulevariable
  ruleConditionString: string = "";
  aggregationstring: string = "";
  searchInput: FormControl = new FormControl('');
  errorState: boolean = false;

  @ViewChild('platform_list') platform_list: ElementRef<HTMLElement>;

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  ngOnInit(): void {

//console.log(JSON.parse(JSON.stringify(this.sharedservice.metaData.alert)))

    // console.log(this.alertvarservice.updateActionMetadata)

//console.log(this.alertActionMetadata)

    // console.log("OnInit", this.alertService.provideeventsdata)

    this.getUserList()
      .then((userlist) => {
        this.alertvarservice.userlist = userlist;
      })
      .catch((err) => {
        this.assigUserSpinnerState = false;
      })
    Object.keys(this.alertvarservice.alertsheetmeta.factsheetMeta.alertUpdateAction.states["status"]).forEach(status => {
      this.alertStatus.push({ "disp": this.alertvarservice.alertsheetmeta.factsheetMeta.alertUpdateAction.states["status"][status]["disp"], "value": status })
    })

    //console.log("fact-sheet ngOnInit==================", this.alertActionMetadata.action_disp)
    this.alertService.getInstantFilters({ "platform": this.alertvarservice.alertscollapsedata.selectedalert.platform }).subscribe(data => {
      this.alertvarservice.instantfilters = Object.keys(this.alertvarservice.instantfilters).length > 1? this.alertvarservice.instantfilters : data;
    })
    this.alertService.provideeventsdata.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
      this.alertvarservice.alertactionmanagement.updateAction.next(['eventsprogress', progress]);
    })

    this.alertService.provideDetaildata.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
      this.alertvarservice.alertactionmanagement.updateAction.next(['detailprogress', progress]);
    })

    this.alertService.provideoverviewdata.isProgress$.pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
      this.alertvarservice.alertactionmanagement.updateAction.next(['overviewprogress', progress]);
    })

    this.alertvarservice.alertactionmanagement.actionManagement
      .pipe(distinctUntilChanged()).pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
        this.isAction = progress;
      })

    this.alertvarservice.eventsItemperpage.valueChanges.subscribe((val) => {
      this.alertvarservice.eventsItemperpage.setValue(val, { emitEvent: false });
      this.fetchPagechangeEvents()
    })

    this.alertvarservice.advancedFilterChange.pipe(takeUntil(this.$destroy))
      .subscribe(() => this.advancedFilterChangeHandle())
    this.alertvarservice.detailsSelectall.valueChanges.subscribe((selected: boolean) => {
      this.updateNodeSummarystatus("valuechange", selected)

    })

    this.alertvarservice.eventsSelectAll.valueChanges.subscribe((selected: boolean) => {
      this.updateSelectedAlertEvents(selected)
      this.selectAllAlertsInPage(selected)

    })

    this.alertvarservice.alertstatus.valueChanges.subscribe((statusVal) => {
      // this.showEventsTable();
    })
    this.alertvarservice.$alertStatusUpdated.pipe(takeUntil(this.$destroy)).subscribe((statusUpdated: boolean) => {
      if (statusUpdated)
        this.showEventsTable();
    })
    this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.valueChanges.subscribe((val) => {
      this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).length, val)
      this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
      this.BuildAlertKeyList()
      this.searchAndPaginationWithSelectedAlerts('itemPerPage')
      // let searchVal = this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSearch.value
      // if(searchVal != ''){
      //   let selected_events_keys = []
      //   Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).map((key) => {
      //     let obj = this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key]
      //     if (this.alertActionMetadata.action_disp[obj["status"]]['status_val'].toLowerCase().includes(searchVal.toLowerCase()) || this.alertActionMetadata.action_disp[obj["alertstate"]]['state_val'].toLowerCase().includes(searchVal.toLowerCase())) {
      //       // || obj["alertstate"].toLowerCase().includes(searchVal.toLowerCase())
      //       selected_events_keys.push(key)
      //     }
      //   })
      //   selected_events_keys.sort((a, b) => parseInt(b) - parseInt(a));
      //   this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      //   this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(this.paginationDataWorkFlowAlert.length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
      //   this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
      // }

      // this.sliceWorkFlowAlerts()
    })

    this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.valueChanges.subscribe((selected: boolean) => {
      // for (let val in this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert) {
      //   // //console.log("this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll===================",selected,val)
      //   this.alertvarservice.alertWorkFlowInfo.selectedAlerts[val].isSelected = selected
      //   // if(this.alertvarservice.AlertEvents.hasOwnProperty(val)){
      //   //   this.alertvarservice.AlertEvents[val].isSelected=selected
      //   // }
      //   // let alertKey = this.alertvarservice.AlertEvents[val]['alerttime'].toString()+this.alertvarservice.AlertEvents[val]['seq_no'].toString()
      //   // this.alertvarservice.alertWorkFlowInfo.selectedAlerts[alertKey] = this.alertvarservice.AlertEvents[val]
      // }
      this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert.forEach((key) => {
        this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key].isSelected = selected
      })

      let isAnyFalse = false
      for (let elementid in this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert) {
        let elementKey = this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert[elementid]
        if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[elementKey].isSelected) {
          isAnyFalse = true
          break
        }
      }
      if (isAnyFalse) {
        // this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })

      }
      else {
        // this.alertvarservice.eventsSelectAll.setValue(true, { emitEvent: false })
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
      }




    })

    this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSearch.valueChanges.subscribe((searchVal) => {
      let selected_events_keys = []
      this.searchAndPaginationWithSelectedAlerts('search')
      // //console.log()
      // if (searchVal != "") {
      //   Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).map((key) => {
      //     let obj = this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key]
      //     if (this.alertActionMetadata.action_disp[obj["status"]]['status_val'].toLowerCase().includes(searchVal.toLowerCase()) || this.alertActionMetadata.action_disp[obj["alertstate"]]['state_val'].toLowerCase().includes(searchVal.toLowerCase())) {
      //       // || obj["alertstate"].toLowerCase().includes(searchVal.toLowerCase())
      //       selected_events_keys.push(key)
      //     }
      //   })
      // }
      // else {
      //   selected_events_keys = Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts)

      // }
      // //console.log("searchVal====", searchVal,selected_events_keys)
      // selected_events_keys.sort((a, b) => parseInt(b) - parseInt(a));
      // this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      // this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(this.paginationDataWorkFlowAlert.length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
      // this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
      // this.sliceWorkFlowAlerts()
    })

    this.alertvarservice.alertEventsSearch.valueChanges.subscribe((searchVal) => {
      // let selected_events_keys = []
      // //console.log("searchVal====", searchVal)
      // if (searchVal != "") {
      //   Object.keys(this.alertvarservice.AlertEvents).map((key) => {
      //     let obj = this.alertvarservice.AlertEvents[key]
      //     if (obj["status"].toLowerCase().includes(searchVal.toLowerCase()) || this.alertActionMetadata.action_disp[obj["alertstate"]].toLowerCase().includes(searchVal.toLowerCase())) {
      //       // || obj["alertstate"].toLowerCase().includes(searchVal.toLowerCase())
      //       selected_events_keys.push(key)
      //     }
      //   })
      // }
      // else {
      //   selected_events_keys = Object.keys(this.alertvarservice.AlertEvents)

      // }
      // selected_events_keys.sort((a, b) => parseInt(b) - parseInt(a));
      // this.alertvarservice.AlertEventsKeyList = selected_events_keys
      if (searchVal == '') {
        this.alertvarservice.alertSearchInfo.invalidSearchKeyStatus = false
        // if(this.alertvarservice.alertSearchInfo.status.length > 0 || this.alertvarservice.alertSearchInfo.status.length > 0){
        this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
        this.alertvarservice.eventspagenumber = 1
        this.alertvarservice.resetAlertSearchObj()
        let reqobj = this.alertvarservice.build_eventReqobj()
        // console.log({ reqobj })
        // this.alertvarservice.alertEventsListView = true;
        this.setupEvents(reqobj);
        // }

      }

    })

    this.getruledata(this.alertvarservice.alertscollapsedata.selectedalert.alertId);
    this.getOverview();
    // this.alertvarservice.alertEventSelectedIndex = 1;
    // this.alertvarservice.isVisibleEvents = true;
    // this.alertvarservice.alertWorkFlowInfo.selectedAlertsEnable = false;
    this.alertvarservice.limitfilter.valueChanges.subscribe((val) => {
      this.alertvarservice.limitfilter.setValue(val, { emitEvent: false });
    })

    this.alertvarservice.detailsSearch.valueChanges.subscribe((searchstr) => {
      this.alertvarservice.filteredNodesumarryArray = JSON.parse(JSON.stringify([
        ...this.alertvarservice.nodesummarydata.series.filter((item: any) => {
          return item['display']['disp'].toLowerCase().includes(searchstr.toLowerCase()) || item['display']['count'].toString().includes(searchstr.toString().toLowerCase()) || item['display']['density'].toLowerCase().includes(searchstr.toLowerCase())
        }),
      ]))
      let selectedListState = true
      this.alertvarservice.filteredNodesumarryArray.forEach(element => {
        if (!element['isSelected']) {
          selectedListState = false
        }
      });
      if (selectedListState) {
        this.alertvarservice.detailsSelectall.setValue(true, { emitEvent: false })
      }
      else {

        this.alertvarservice.detailsSelectall.setValue(false, { emitEvent: false })
      }
      if (this.alertvarservice.filteredNodesumarryArray.length == 0) {
        this.alertvarservice.detailsSelectall.setValue(false, { emitEvent: false })
        this.alertvarservice.detailsSelectall.disable({ emitEvent: false })
      }
      else {
        this.alertvarservice.detailsSelectall.enable({ emitEvent: false })
      }
    })


  }
  ngAfterViewInit(): void {
    // this.alertvarservice.$showEvents.subscribe((data) => {
    //   this.load_chart()
    // })
  }




  get_alerts_events_len(mode: string) {
    let count = 0;
    Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
      // count += Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch]).length
      Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch]).map((key: any) => {
        // Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][key]).map((alertkey: any) => {
        if (this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][key]["selected"]) {
          count += 1
        }
        // })
      })
    })
    return count
    // if (mode == "alerts") {
    //   return Object.keys(this.alertvarservice.AlertEvents).length
    // }
    // else {
    //   return Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).length
    // }
  }


  BuildAlertKeyList() {
    this.alertvarservice.alertWorkFlowInfo.alertKeys_list = Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts)
    this.alertvarservice.alertWorkFlowInfo.alertKeys_list.sort((a, b) => b - a);
  }

  changeFilterTab(index: number) {
    this.alertvarservice.currentIndex = index;
  }
  changeTab(index: number) {
    
    // this.alertvarservice.currentIndex = index;
    this.alertvarservice.alertEventSelectedIndex = index;
    this.BuildAlertKeyList()
    this.sliceWorkFlowAlerts()
    let alertWorkFlowState = true
    this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert.map((key: string) => {
      if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key].isSelected) {
        alertWorkFlowState = false
      }
    })
    this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(alertWorkFlowState, { emitEvent: false })
    this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
    this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1

    if (index == 1) {
      if (this.alertvarservice.lastClickedNode.id != this.alertvarservice.previousselectedNode) {
        let reqobj = this.alertvarservice.build_eventReqobj()
        // console.log("->", reqobj)
        this.setupEvents(reqobj);
      }

    }

    // this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
    // 

    // let selectedAlertStatus = true
    // if (this.alertvarservice.alertWorkFlowInfo.alertKeys_list.length != 0) {
    //   this.alertvarservice.alertWorkFlowInfo.alertKeys_list.forEach((item) => {
    //     //console.log(item, !this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected)
    //     if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected) {
    //       selectedAlertStatus = false
    //       // return false
    //     }
    //   })
    // }
    // else {
    //   selectedAlertStatus = false
    // }

    // //console.log("changeTab==========", selectedAlertStatus)
    // if (selectedAlertStatus) {
    //   this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
    //   if (this.alertvarservice.alertWorkFlowInfo.alertKeys_list.length == this.alertvarservice.AlertEventsKeyList.length) {
    //     this.alertvarservice.eventsSelectAll.setValue(true, { emitEvent: false })
    //   }
    //   // this.alertvarservice.eventsSelectAll.setValue(,{emitEvent:false})
    // }
    // else {
    //   this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    //   this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
    // }

  }
  // showEvents() {
  //   this.alertvarservice.isEventsTable = true;
  //   if (this.alertvarservice.isVisibleEvents == true) {
  //     this.showEventsTable();
  //   }
  //   // else
  //   //   this.alertvarservice.alertEventSelectedIndex = 0
  // }

  closeEventsPanel() {
    // this.alertvarservice.currentIndex = 1
    // this.alertvarservice.isVisibleEvents = false;
    this.alertvarservice.alertEventsListView = true;
    this.alertvarservice.eventlist.length = 0;

  }
  filterAlertEvents() {
    this.clearAllSelectedAlerts()
    this.showEventsTable()
  }
  showEventsTable() {
    this.alertvarservice.resetEventsPagination();
    const reqobj = {
      ...this.alertvarservice.build_eventReqobj(),
      "search": this.alertvarservice.alertEventsSearch.value
    };
    // this.alertvarservice.eventsPanel = FactsheetEventsPanel.collapse;
    // this.alertvarservice.collapseEventsPanel()
    // this.alertvarservice.isVisibleEvents = true;
    // this.alertvarservice.isEventsTable = false;
    this.alertvarservice.alertEventsListView = true;
    // console.log("=>", reqobj)
    this.setupEvents(reqobj);

    setTimeout(() => {
      this.load_chart()
    }, 100);
  }


  setupEvents(reqobj: any) {
    if (this.alertvarservice.alertEventSelectedIndex == 1) {
      this.alertvarservice.previousselectedNode = this.alertvarservice.lastClickedNode.id
      this.requestEventsData(reqobj);
    }
  }

  requestNodeDetail(reqobj: any) {
    this.alertvarservice.handleDetaildataerror.resetError();
    this.alertvarservice.nodesummarydata.series.length = 0;
    this.alertService.provideDetaildata.postrequest(reqobj)
      .pipe(takeUntil(this.$destroy))
      .subscribe((data) => {
        this.alertvarservice.nodesummarydata = data;
      },
        (error) => {
          this.alertvarservice.handleDetaildataerror.seterror(true, error.error?.errmsg)
        })
  }

  createDetailReqobj(node_info: any) {
    var nodeList = this.alertvarservice.getBubbleValues(node_info)
    const reqobj = {
      'alertId': this.alertvarservice.alertscollapsedata.selectedalert.alertId,
      'season_time': [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      'episode_duration': this.alertvarservice.advanced_filter_values.time_interval.value,
      node: node_info["node"],
      node_list: nodeList,
      node_type: nodeList.length ? "value" : "all"
    }
    return reqobj;
  }


  setDetailsSelectallValue(status: boolean) {
    if (this.alertvarservice.detailsSelectall.getRawValue() || status) {
      this.alertvarservice.detailsSelectall.setValue(status, { emitEvent: false });
    }

  }
  addNodeSummarydataControl(defaultControlValue: boolean) {
    this.alertvarservice.filteredNodesumarryArray = []
    for (let i = 0; i < this.alertvarservice.nodesummarydata.series.length; i++) {
      this.alertvarservice.nodesummarydata.series[i]["index"] = i.toString()
      this.alertvarservice.nodesummarydata.series[i]["isSelected"] = defaultControlValue
    }
    this.alertvarservice.filteredNodesumarryArray = JSON.parse(JSON.stringify(this.alertvarservice.nodesummarydata.series))
  }

  updateNodeSummarystatus(mode: string, state: boolean) {
    this.alertvarservice.nodeSummaryDetailSelectedCount = 0
    for (let j = 0; j < this.alertvarservice.filteredNodesumarryArray.length; j++) {
      this.alertvarservice.filteredNodesumarryArray[j]["isSelected"] = state
      this.alertvarservice.nodesummarydata.series[parseInt(this.alertvarservice.filteredNodesumarryArray[j]['index'])]["isSelected"] = state

    }
    this.alertvarservice.nodesummarydata.series.forEach((item) => {
      this.alertvarservice.nodeSummaryDetailSelectedCount += item['isSelected'] ? 1 : 0
    })
    // for (let i = 0; i < this.alertvarservice.nodesummarydata.series.length; i++) {
    //   this.alertvarservice.nodesummarydata.series[i]["isSelected"] = state
    // }
    if (mode == 'clear') {
      this.setDetailsSelectallValue(false)
    }
  }

  showDetail() {
    this.alertvarservice.nodesummarydata.series.length = 0;
    this.alertvarservice.handleDetaildataerror.resetError();
    this.alertvarservice.detailsSearch.setValue("", { emitEvent: false });
    const node_info = this.alertvarservice.nodeinfo;
    this.alertvarservice.nodesummarydata.series = []

    if (node_info.bubbles.length > 0) {
      // calculate max alert count
      const maxCount = node_info.bubbles.reduce((max, current) => {
        return current.count > max ? current.count : max;
      }, node_info.bubbles[0].count)

      if (node_info.node == "Episodes") {
        for (let index = 0; index < node_info.bubbles.length; index++) {
          let obj = {
            "value": node_info.bubbles[index].value,
            "display": {
              "disp": "",
              "count": node_info.bubbles[index].count,
              "density": node_info.bubbles[index].count > maxCount * 0.75 ? 'high' : node_info.bubbles[index].count < maxCount * 0.25 ? 'low' : 'medium'
            },
            "isSelected": false,
            "bubble_id": node_info.bubbles[index].id
          }
          if (this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value)).format("YYYY MMM DD") === this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value) + (60 * this.alertvarservice.advanced_filter_values.time_interval.value)).format("YYYY MMM DD")) {

            obj['display']['disp'] = this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value) + (60 * this.alertvarservice.advanced_filter_values.time_interval.value)).format("HH:mm")   //"2025 Jan 25 21:00 - 21:10",
          }
          else {
            if (this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value) + (60 * this.alertvarservice.advanced_filter_values.time_interval.value)).format("HH:mm") == '00:00') {
              obj['display']['disp'] = this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value) + (60 * this.alertvarservice.advanced_filter_values.time_interval.value)).format("HH:mm")   //"2025 Jan 25 21:00 - 21:10",
            }
            else {
              obj['display']['disp'] = this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value)).format("YYYY MMM DD HH:mm") + " - " + this.timezoneservice.toUserTimeZone(parseInt(node_info.bubbles[index].value) + (60 * this.alertvarservice.advanced_filter_values.time_interval.value)).format("YYYY MMM DD HH:mm")   //"2025 Jan 25 22:00 - 2025 Jan 26 01:00",
            }
          }

          this.alertvarservice.nodesummarydata.series.push(obj)
        }
        this.alertvarservice.nodesummarydata.series.sort((a, b) => a.value - b.value);
      } else {
        for (let index = 0; index < node_info.bubbles.length; index++) {
          let obj = {
            "value": node_info.bubbles[index].value,
            "display": { "disp": node_info.bubbles[index].value, "count": node_info.bubbles[index].count, "density": node_info.bubbles[index].count > maxCount * 0.75 ? 'high' : node_info.bubbles[index].count < maxCount * 0.25 ? 'low' : 'medium' },
            "isSelected": false,
            "bubble_id": node_info.bubbles[index].id
          }
          this.alertvarservice.nodesummarydata.series.push(obj);

        }
        this.alertvarservice.nodesummarydata.series.sort((a, b) => b.display.count - a.display.count);
      }

      this.cancel_filter_state = this.alertvarservice.nodeinfo.filters.length == 0 ? true : false
      this.alertvarservice.nodeSummaryDetailSelectedCount = 0
      this.setDetailsSelectallValue(false)
      this.addNodeSummarydataControl(false)
    } else {
      this.alertvarservice.handleDetaildataerror.seterror(true, "No details found")
    }
    //additional filter
    if (this.alertvarservice.nodeinfo.advanceFilterDisplay.length) {
      this.alertvarservice.filtercondition.clear()
      this.setAdditionalFilters(this.alertvarservice.filtercondition, this.alertvarservice.nodeinfo.advanceFilterDisplay)
    } else {
      this.alertvarservice.filtercondition.clear()
      this.alertvarservice.addconditionSet()
    }

    // this.getLegendHasAlertCount();
  }

  getOverview() {
    this.alertvarservice.handleOverviewdataerror.resetError();
    this.alertvarservice.overviewDetails.length = 0;
    const alertdetails = {
      alertId: this.alertvarservice.alertscollapsedata.selectedalert.alertId,
      // season_time: [this.alertvarservice.advanced_filter_values.start_time, this.alertvarservice.advanced_filter_values.end_time],
      season_time: [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      episode_duration: this.alertvarservice.advanced_filter_values.time_interval.value,
      platform: this.alertvarservice.alertscollapsedata.selectedalert.platform
    };
    this.alertService.provideoverviewdata.postrequest(alertdetails)
      .subscribe(overviewdata => {
        if (overviewdata.length) {
          this.alertvarservice.overviewDetails = [...overviewdata]
          this.insightDetails["Inspection Details"]["Start Time"] = this.alertvarservice.overviewDetails[0]["Inspection Start"]
          this.insightDetails["Inspection Details"]["End Time"] = this.alertvarservice.overviewDetails[0]["Inspection End"]
          this.insightDetails["Inspection Details"]["Duration"] = this.alertvarservice.overviewDetails[0]["Inspection Duration"]

          this.insightDetails["Episode Insight"]["Episode Length"] = this.alertvarservice.overviewDetails[0]["Episode Length"]
          this.insightDetails["Episode Insight"]["Episodes Without Alerts / Total Episodes"] = (this.alertvarservice.overviewDetails[1]['Episodes in Time Range'] - this.alertvarservice.rootNodeEpisodesCount).toString() + " of " + this.alertvarservice.overviewDetails[1]['Episodes in Time Range'].toString() + " (" + (((this.alertvarservice.overviewDetails[1]['Episodes in Time Range'] - this.alertvarservice.rootNodeEpisodesCount) / this.alertvarservice.overviewDetails[1]['Episodes in Time Range']) * 100).toString() + "%)"
          this.insightDetails["Episode Insight"]["Avg. Alerts per Episode"] = this.alertvarservice.overviewDetails[1]['Alerts in Time Range'] / this.alertvarservice.overviewDetails[1]['Episodes in Time Range']

          this.insightDetails["Source & Field Details"]["Active Sources / Total Sources"] = this.alertvarservice.overviewDetails[1]['Number of Active Sources']
          this.insightDetails["Source & Field Details"]["Field Coverage"] = 0

          this.insightDetails["Alert Insights"][0]["current_inspection_duration"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['inspectionRuleCount'])
          this.insightDetails["Alert Insights"][0]["till_date"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['tilldateRuleCount'])
          this.insightDetails["Alert Insights"][0]["total_percentage"] = this.alertvarservice.overviewDetails[2]['tilldateRuleCount'] ? ((this.alertvarservice.overviewDetails[2]['inspectionRuleCount'] / this.alertvarservice.overviewDetails[2]['tilldateRuleCount']) * 100).toFixed(2) : '0.00'

          this.insightDetails["Alert Insights"][1]["current_inspection_duration"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['inspectionplatformCount'])
          this.insightDetails["Alert Insights"][1]["till_date"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['tilldateplatformCount'])
          this.insightDetails["Alert Insights"][1]["total_percentage"] = this.alertvarservice.overviewDetails[2]['tilldateplatformCount'] ? ((this.alertvarservice.overviewDetails[2]['inspectionplatformCount'] / this.alertvarservice.overviewDetails[2]['tilldateplatformCount']) * 100).toFixed(2) : '0.00'

          this.insightDetails["Alert Insights"][2]["current_inspection_duration"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['inspectionallplatformCount'])
          this.insightDetails["Alert Insights"][2]["till_date"] = this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[2]['tilldateallplatformcount'])
          this.insightDetails["Alert Insights"][2]["total_percentage"] = this.alertvarservice.overviewDetails[2]['tilldateallplatformcount'] ? ((this.alertvarservice.overviewDetails[2]['inspectionallplatformCount'] / this.alertvarservice.overviewDetails[2]['tilldateallplatformcount']) * 100).toFixed(2) : '0.00'


        } else {
          this.alertvarservice.handleOverviewdataerror.seterror(true, "No data found");
        }

      }, (error) => {
        this.alertvarservice.handleOverviewdataerror.seterror(true, error.error?.errmsg)
      })
  }

  getruledata(alertid: any) {
    this.alertService.provideruleDetails({ "alertid": alertid }).subscribe(ruledetails => {
      this.alertvarservice.ruledetailsdata = { ...ruledetails };
      this.buildRuleConditionString()
      this.alertvarservice.handleprovideruledataerror.seterror(false, null);
    },
      (error) => {
        this.alertvarservice.handleprovideruledataerror.seterror(true, error.error?.errmsg);
      })
  }

  openRuleInfo(template: any, origin: any) {
    let ruleDetails: any = this.alertvarservice.ruledetailsdata;
    if (!this.alertvarservice.handleprovideruledataerror.status) {
      this.ruleConditionString = ruleDetails.ruleCondition;
      if (ruleDetails.ruleType == 'frequency') {
        this.aggregationstring = "Pivot on fields = " + ruleDetails.aggregationCondition.pivotFields.join() +
          "\n " + ruleDetails.aggregationCondition.aggregateFunction + " (" + ruleDetails.aggregationCondition.aggregateFunctionField[0] +
          ") " + ruleDetails.aggregationCondition.thresholdOperator + " " + ruleDetails.aggregationCondition.thresholdValue +
          " in " + ruleDetails.aggregationCondition.aggregateTime + " " + ruleDetails.aggregationCondition.aggregateTimeUnit
      }
    }
    let config = {
      data: {
        "template": template
      },
      width: "63vw",
    }
    this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin)
  }

  buildRuleConditionString() {
    let ruleDetails: any = this.alertvarservice.ruledetailsdata;
    if (!this.alertvarservice.handleprovideruledataerror.status) {
      this.ruleConditionString = ruleDetails.ruleCondition;
      if (ruleDetails.ruleType == 'frequency') {
        this.aggregationstring = "Pivot on fields = " + ruleDetails.aggregationCondition.pivotFields.join() +
          "\n " + ruleDetails.aggregationCondition.aggregateFunction + " (" + ruleDetails.aggregationCondition.aggregateFunctionField[0] +
          ") " + ruleDetails.aggregationCondition.thresholdOperator + " " + ruleDetails.aggregationCondition.thresholdValue +
          " in " + ruleDetails.aggregationCondition.aggregateTime + " " + ruleDetails.aggregationCondition.aggregateTimeUnit
      }
    }
    return this.aggregationstring
  }

  detailSelected(index: number, filter_index) {
    this.alertvarservice.filteredNodesumarryArray[filter_index]['isSelected'] = !this.alertvarservice.filteredNodesumarryArray[filter_index]['isSelected']
    this.alertvarservice.nodesummarydata.series[index].isSelected = !this.alertvarservice.nodesummarydata.series[index].isSelected;
    let isselectedState = true
    this.alertvarservice.filteredNodesumarryArray.forEach((item) => {
      if (!item['isSelected']) {
        isselectedState = false
        return 1
      }

    })
    this.setDetailsSelectallValue(isselectedState)

    this.alertvarservice.nodeSummaryDetailSelectedCount = 0
    this.alertvarservice.nodesummarydata.series.forEach((item) => {
      this.alertvarservice.nodeSummaryDetailSelectedCount += item['isSelected'] ? 1 : 0
    })
    // }



  }

  clearNodeSummaryDetails() {
    if (!this.isAction) {
      this.alertvarservice.resetPreviousNodeSelection()
      let filter = []
      this.alertvarservice.nodeFilter.next(filter)
    }
  }

  detailApplyClick() {
    if (!this.isAction) {
      const filteredList = this.alertvarservice.nodesummarydata.series.filter((element) => element.isSelected);
      var filter = []
      filteredList.forEach(element => {
        filter.push(element.value)
      });
      if (filter.length > 0) {
        this.alertvarservice.resetPreviousNodeSelection()
        this.alertvarservice.nodeFilter.next(filter)
      }
      else {
        // //console.log("node details not selected====================")
      }


    }

  }

  createEventsReqobj(node_info: any, pagination: boolean) {
    let node_type = "";
    if (node_info.node_list.length) {
      node_type = "value";
    } else {
      node_type = "all";
    }

    return {
      'alertId': this.alertvarservice.alertscollapsedata.selectedalert.alertId,
      'season_time': [this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      'episode_duration': this.alertvarservice.advanced_filter_values.time_interval.value,
      'node_type': node_type,
      ...node_info,
      'pagination': pagination,
      'page_no': this.alertvarservice.eventspagenumber,
      'itemsper_page': this.alertvarservice.eventsItemperpage.getRawValue()
    }
  }


  restartAlertWorkflows() {
    this.alertvarservice.latestselected_alert = {}
    this.selectedEvent = ''
    this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
    this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    this.alertvarservice.alertWorkFlowInfo.selectedAlerts = {}
    this.alertvarservice.alertWorkFlowInfo.alertKeys_list = []
    this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = []
    this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
    this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = 1
    this.alertvarservice.alertWorkFlowInfo.selectedAlertsEnable = true
  }

  requestEventsData(reqobj: any) {
//console.log("API call")
    this.alertvarservice.eventlist.length = 0;
    this.alertvarservice.handleprovideeventsdataerror.resetError();
    this.alertvarservice.eventsSelectAll.disable({ emitEvent: false });
    this.alertService.provideeventsdata.postrequest(reqobj)
      .pipe(takeUntil(this.alertService.factsheetcomponentDestroyed))
      .subscribe((response) => {
//console.log({response})
        if (reqobj['pagination']) {
          this.alertvarservice.AlertEventsCount = response.alertcount
          this.alertvarservice.eventspagelength = this.alertvarservice.calculatepagelength(response.alertcount, this.alertvarservice.eventsItemperpage.value)
        }
        if (response.eventList.length) {
          let eventDetails = {}
          response.eventList.map((item: any, index: number) => {
            let key = (this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1
            if (this.isAlertInCurrentPageSlected(this.alertvarservice.eventspagenumber, index, this.alertvarservice.eventsItemperpage.value, key)) {

              return { ...item, "isSelected": true, "read": false }
            }
            else return { ...item, "isSelected": false, "read": false }
          })
          response.eventList.map((item: any, index: number) => {
            let key = (this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1

            eventDetails[key] = { ...item, "isSelected": false, "read": false }
            if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(key)) {
              eventDetails[key]['isSelected'] = true

            }
          })
          this.alertvarservice.eventlist = [...response.eventList];

          this.alertvarservice.AlertEventsKeyList = Object.keys(eventDetails)
          this.alertvarservice.AlertEventsKeyList.sort((a, b) => parseInt(b) - parseInt(a));
          this.selectedEvent = this.alertvarservice.AlertEventsKeyList[0]


          this.alertvarservice.AlertEvents = eventDetails

//console.log("AlertEvents =---->", this.alertvarservice.AlertEvents)
          this.alertvarservice.latestselected_alert = { ...this.alertvarservice.AlertEvents[this.selectedEvent] }

          this.getHistoryInfo()
        } else {
          if (response.alertcount == -1) {
            this.alertvarservice.handleprovideeventsdataerror.seterror(true, this.alertvarservice.alertsheetmeta.noDatamsg[2])
          }
          else {
            this.alertvarservice.handleprovideeventsdataerror.seterror(true, this.alertvarservice.alertsheetmeta.noDatamsg[1]);
          }

        }
        this.alertvarservice.eventsSelectAll.enable({ emitEvent: false });
        if (this.alertvarservice.SelectAllAlerts) {
          this.SelectUntouchedAlerts()
        }
        let alerts_state = true

        for (let index = 0; index < this.alertvarservice.eventsItemperpage.value; index++) {
          let batch = this.getRangeGroup((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)
          let eventRefKey = (this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1

          if (batch in this.alertvarservice.eventWorkFlowInfo.selectedAlerts) {
            if (!(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch].hasOwnProperty(eventRefKey))) {
              alerts_state = false
            }
            else if (this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch].hasOwnProperty(eventRefKey)) {
              if (!this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][eventRefKey]["selected"]) {
                alerts_state = false
              }
            }
          }
          else {
            alerts_state = false
          }
        }
        this.alertvarservice.eventsSelectAll.setValue(alerts_state, { emitEvent: false })

      },
        (error) => {
          this.restartAlertWorkflows()
          this.alertvarservice.handleprovideeventsdataerror.seterror(true, error.error?.errmsg);
          this.alertvarservice.eventsSelectAll.enable({ emitEvent: false });
        })
  }
  showMatchedEvent() {
    // //console.log("showMatchedEvent",this.selectedEvent,this.alertvarservice.AlertEvents[this.selectedEvent],this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEvent])
    // if(this.selectedEvent = ''){
    //   return undefined
    // }
    if (this.alertvarservice.AlertEvents.hasOwnProperty(this.selectedEvent)) {
      return this.alertvarservice.AlertEvents[this.selectedEvent]
    }
    else {
      return this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEvent]
    }
  }
  summaryStyles() {
    if (this.alertvarservice.summaryPanel == 0) {
      return {
        "width": "2vw",
        // "max-width":"2vw",
        "position": "unset"
      }
    } else if (this.alertvarservice.summaryPanel == 1) {
      return {
        "width": "40%",
        // "max-width":"40vw",
        "position": "unset"
      }

    } else if (this.alertvarservice.summaryPanel == 2) {
      return {
        "width": '92%',
        // "max-width":"92vw",
        "position": "absolute"
      }
    }
  }

  eventPanelStyles() {
    if (this.alertvarservice.eventsPanel == 0) {
      return {
        "height": "5vh",
      }
    } else if (this.alertvarservice.eventsPanel == 1) {
      return {
        "height": "46vh",
      }

    } else if (this.alertvarservice.eventsPanel == 2) {
      return {
        "height": "84vh",
      }
    }
  }
  visualizeContainerStyles() {
    if (this.alertvarservice.eventsPanel == 0) {
      return "previewContainer"
    } else if (this.alertvarservice.eventsPanel == 2 && this.alertvarservice.summaryPanel) {
      return "previewContainer-expand-summary-expand"
    } else if (this.alertvarservice.eventsPanel == 1 && this.alertvarservice.summaryPanel) {
      return "previewContainer-collapse-summary-expand"
    } else if (this.alertvarservice.eventsPanel == 2 && !this.alertvarservice.summaryPanel) {
      return "previewContainer-expand-summary-collapse"
    } else if (this.alertvarservice.eventsPanel == 1 && !this.alertvarservice.summaryPanel) {
      return "previewContainer-collapse-summary-collapse"
    }
  }

  graphPanelStyles() {
    if (this.alertvarservice.eventsPanel == FactsheetEventsPanel.closed) {
      return { "height": "93.5%" }
    }
    // if (this.alertvarservice.isVisibleEvents) {
    //   if (this.alertvarservice.eventsPanel == FactsheetEventsPanel.closed) {
    //     return { "height": "93.5%" }
    //   }
    // } else {
    //   return { "height": "100%" }
    // }
  }
  updateSelectedAlertEvents(status: boolean) {
    if (status) {
      for (let val in this.alertvarservice.AlertEvents) {
        this.alertvarservice.AlertEvents[val].isSelected = status

        let alertKey = this.alertvarservice.AlertEvents[val]['alerttime'].toString() + this.alertvarservice.AlertEvents[val]['seq_no'].toString()
        this.alertvarservice.alertWorkFlowInfo.selectedAlerts[alertKey] = JSON.parse(JSON.stringify(this.alertvarservice.AlertEvents[val]))
        this.BuildAlertKeyList()
      }
    }
    else {
      for (let val in this.alertvarservice.AlertEvents) {
        this.alertvarservice.AlertEvents[val].isSelected = status

        let alertKey = this.alertvarservice.AlertEvents[val]['alerttime'].toString() + this.alertvarservice.AlertEvents[val]['seq_no'].toString()
        delete this.alertvarservice.alertWorkFlowInfo.selectedAlerts[alertKey]
        this.alertvarservice.alertWorkFlowInfo.alertKeys_list?.splice(this.alertvarservice.alertWorkFlowInfo.alertKeys_list.indexOf(alertKey), 1)

      }

    }
  }

  selectAlert(event: any, key: string) {
    // this.alertvarservice.currentIndex = 3
    event.stopPropagation()

    this.alertvarservice.AlertEvents[key].isSelected = !this.alertvarservice.AlertEvents[key].isSelected;

    // let alertKey = this.alertvarservice.eventlist[index]['alerttime'].toString()+this.alertvarservice.eventlist[index]['seq_no'].toString()
    if (this.alertvarservice.AlertEvents[key].isSelected) {
      // this.alertvarservice.eventlist[index]
      this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key] = JSON.parse(JSON.stringify(this.alertvarservice.AlertEvents[key]))
      // this.BuildAlertKeyList()

    }
    else {
      if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(key)) {
        delete this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key]
        this.alertvarservice.alertWorkFlowInfo.alertKeys_list?.splice(this.alertvarservice.alertWorkFlowInfo.alertKeys_list.indexOf(key), 1)

      }
    }
    this.sliceWorkFlowAlerts()
    let isAnyFalse = false
    for (let elementKey in this.alertvarservice.AlertEvents) {
      if (!this.alertvarservice.AlertEvents[elementKey].isSelected) {
        isAnyFalse = true
        break
      }
    }
    if (isAnyFalse) {
      this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
      this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })

    }
    else {
      this.alertvarservice.eventsSelectAll.setValue(true, { emitEvent: false })
      this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
    }
  }



  selectedWorkFlowAlert(event: any, key: string) {
    event.stopPropagation()
    this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key].isSelected = !this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key].isSelected;


    // for (let elementKey in this.alertvarservice.alertWorkFlowInfo.selectedAlerts) {
    //   //console.log("selectedWorkFlowAlert=============", this.alertvarservice.alertWorkFlowInfo.selectedAlerts, elementKey)
    //   if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[elementKey].isSelected) {
    //     isAnyFalse = false
    //     break
    //   }
    // }
    let isAnyFalse = true
    for (let elementIndex in this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert) {
      let elementval = this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert[elementIndex]
      if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[elementval].isSelected) {
        isAnyFalse = false
        break
      }
    }
    if (isAnyFalse) {
      this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
    }
    else {
      this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    }

  }

  selectAll(event: any) {
    event.stopPropagation()
    this.alertvarservice.eventsSelectAll.setValue(!this.alertvarservice.eventsSelectAll.value)
    // if (this.alertvarservice.eventsSelectAll.value) {
    //   for (let index = 0; index < this.alertvarservice.eventlist.length; index++) {
    //     this.alertvarservice.eventlist[index].isSelected = true
    //   }
    // }
    for (let elementKey in this.alertvarservice.AlertEvents) {
      this.alertvarservice.AlertEvents[elementKey].isSelected = true
    }

  }

  getHistoryInfo() {
    // history get is not used currently, so it was commented out
    // setTimeout(() => {
    //   this.alertvarservice.latestselected_alert['read'] = true;
    //   this.alertvarservice.historyList.length = 0;
    //   this.alertvarservice.notesList.length = 0;

    //   let reqobj = {
    //     "alertId": this.alertvarservice.alertscollapsedata.selectedalert.alertId,
    //     "alerttime": this.alertvarservice.latestselected_alert['alerttime'],
    //     "seq_no": this.alertvarservice.latestselected_alert['seq_no'],
    //     "platform": this.alertvarservice.alertscollapsedata.selectedalert.platform
    //   }

    //   this.alertService.provideHistoryGet(reqobj)
    //     .pipe(takeUntil(this.$destroy))
    //     .subscribe((data: any) => {
    //       // //console.log(data)
    //       for (let key in data) {
    //         if (data[key].hasOwnProperty('action')) {
    //           this.alertvarservice.historyList.push({ "time": key, "value": data[key] })
    //         }
    //         else if (data[key].hasOwnProperty('notes')) {
    //           this.alertvarservice.notesList.push({ "time": key, "value": data[key] })
    //         }
    //       }
    //       // this.alertvarservice.historyList = data;
    //     },
    //       (error) => {
    //         //console.log(error);
    //         // this.alertvarservice.handleDetaildataerror.seterror(true, error.error?.errmsg)
    //       })
    // }, 0)
  }

  openFactsheet(alert: any, alertKey: string, mode: string, event: any) {
    event.stopPropagation()
    this.selectedEvent = alertKey
    let startindex = 0
    if (mode == 'Alerts') {
      // this.alertvarservice.currentIndex = 1
      startindex = this.alertvarservice.AlertEventsKeyList.indexOf(this.selectedEvent)
      this.alertvarservice.latestselected_alert = { ...this.alertvarservice.AlertEvents[alertKey] };
    }
    else {
      // this.alertvarservice.currentIndex = 2
      startindex = this.alertvarservice.alertWorkFlowInfo.alertKeys_list.indexOf(this.selectedEvent)
      this.alertvarservice.latestselected_alert = { ...this.alertvarservice.alertWorkFlowInfo.selectedAlerts[alertKey] };
    }

    // //console.log("event cliked...",alert);
    // this.alertvarservice.selectedEventPagenumber = index + 1;
    // this.alertvarservice.selectedEventPagelenght = this.alertvarservice.eventlist.length;


    // alert.read = true;
    this.getHistoryInfo()
    const alertsEventsPopupView = this.matdialog.open(ShowPopupEventsComponent, {
      width: "46vw",
      height: "65vh",
      data: {
        "title": "Matched event",
        startIndex: startindex,
        "mode": mode
      },
      autoFocus: false,
      disableClose: true
    })
    alertsEventsPopupView.afterClosed().subscribe((dat) => {
      if (dat) {
        // //console.log("ShowPopupEventsComponent  closed")
      }
    })

  }

  openAdditionalEvents(alert: any) {
    if (alert.additionalevents.length) {
      const reqobj = {
        additionalevents: [...alert.additionalevents],
        alertid: this.alertvarservice.alertscollapsedata.selectedalert.alertId
      }
      this.additionalEventsSpinnerState = true;
      this.getAdditionalevents(reqobj)
    }
  }

  getAdditionalevents(reqobj: any) {
    this.alertService.provideadditionalevents().postrequest(reqobj)
      .subscribe((additionallist) => {
        this.additionalEventsSpinnerState = false;
        // //console.log(additionallist);
        const addeventsdialogRef = this.matdialog.open(AdditionalEventsComponent, {
          width: "60vw", height: "80vh", data: { additionallist }, autoFocus: false,
          disableClose: true
        })
      }, (error) => {
        this.additionalEventsSpinnerState = false;
        //console.log(error);
      })
  }


  // getUserList() {
  //   return new Promise((resolve, reject) => {
  //     this.settingsService.getroleUserList().
  //       subscribe((data: any) => {
  //         resolve(data);
  //       },
  //         (error) => {
  //           reject(error);
  //         })
  //   })
  // }

  getUserList() {
    return new Promise((resolve, reject) => {
      this.alertService.getAnalytsList().
        subscribe((data: any) => {
          resolve(data);
        },
          (error) => {
            reject(error);
          })
    })
  }

  assignUser() {
    if (!this.isAction) {
      const selectedAlert = []
      // this.alertvarservice.eventlist.map((event, index) => {
      //   if (event.isSelected) {
      //     selectedAlert.push(index);
      //   }
      // })


      this.alertvarservice.AlertEventsKeyList.forEach(element => {
        if (this.alertvarservice.AlertEvents[element].isSelected) {
          selectedAlert.push(element);
        }
      });
      if (this.get_alerts_events_len('selectedAlerts') || this.alertvarservice.SelectAllAlerts) {
        this.openAssignUser(selectedAlert);
      }
      else {
        this.alertvarservice.createtoastmsg({
          type: "warning",
          "text": "No alert has been selected"
        })
      }
    }

  }



  updateAction() {
    if (!this.isAction) {
      const selectedAlert = [];
      this.alertvarservice.alertWorkFlowInfo.alertKeys_list.forEach((item) => {
        if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected) {
          selectedAlert.push(item)
        }
      })
      if (this.get_alerts_events_len('selectedAlerts') || this.alertvarservice.SelectAllAlerts) {

        this.openUpdateAction(this.alertvarservice.alertWorkFlowInfo.alertKeys_list);
      }
      else {
        this.alertvarservice.createtoastmsg({
          type: "warning",
          "text": "No alert has been selected"
        })
      }
    }
  }
  updateActionNew(alertActions) {
    if (!this.isAction) {
      const selectedAlert = [];
      this.alertvarservice.alertWorkFlowInfo.alertKeys_list.forEach((item) => {
        if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected) {
          selectedAlert.push(item)
        }
      })
      if (this.get_alerts_events_len('selectedAlerts') || this.alertvarservice.SelectAllAlerts) {

        this.openUpdateActionNew(alertActions);
      }
      else {
        this.alertvarservice.createtoastmsg({
          type: "warning",
          "text": "No alert has been selected"
        })
      }
    }
  }

  assignSelectedAlert() {
    if (!this.isAction) {
      this.openAssignUser([this.alertvarservice.selectedEventPagenumber - 1]);
    }
  }

  openAssignUser(selectedAlert: any[]) {
    // if (selectedAlert.length) {
    this.assigUserSpinnerState = true;
    this.getUserList()
      .then((userlist) => {
        this.assigUserSpinnerState = false;
        const userdialogRef = this.matdialog.open(AssignUserComponent, {
          width: "30vw", height: "50vh", data: { userlist, selectedAlert }, autoFocus: false,
          disableClose: true
        })
        userdialogRef.afterClosed().subscribe((dat) => {
          if (dat) {
            this.getHistoryInfo()
            this.clearAllSelectedAlerts()
          }
        })
      })
      .catch((err) => {
        this.assigUserSpinnerState = false;
      })
    // } else {
    //   //No alert selected Toaster
    //   this.alertvarservice.createtoastmsg({
    //     type: "warning",
    //     "text": "No alert selected"
    //   })
    // }

  }

  addNotes() {
    if (!this.isAction) {
      const selectedAlert = [];
      this.alertvarservice.eventlist.map((event, index) => {
        if (event.isSelected) {
          selectedAlert.push(index);
        }
      })
      this.openAddNotes(selectedAlert);
    }
  }

  addNotestSelectedAlert() {
    if (!this.isAction) {
      this.openAddNotes([this.alertvarservice.selectedEventPagenumber - 1]);
    }
  }

  openAddNotes(selectedAlert: any[]) {
    let addNotesList = this.alertvarservice.addNotesList


    if (selectedAlert.length) {

      const notesdialogRef = this.matdialog.open(AddNotesComponent, {
        width: "49vw", height: "50vh", data: { addNotesList, selectedAlert }, autoFocus: false,
        disableClose: true
      })
      notesdialogRef.afterClosed().subscribe((dat) => {
        if (dat) {
          this.getHistoryInfo()
        }
      })
    } else {
      this.alertvarservice.createtoastmsg({
        type: "warning",
        "text": "No alert selected"
      })
    }
  }

  // openUpdateActionNew(selectedstatus: any) {
  //   // if (selectedAlert.length) {
  //   this.assigUserSpinnerState = true;
  //   this.getUserList()
  //     .then((userlist) => {
  //       this.assigUserSpinnerState = false;
  //       const updateactionRef = this.matdialog.open(UpdateActionComponent, {
  //         width: "60vw", height: "50vh", data: { userlist, selectedstatus, "alertActionMetadata": this.alertActionMetadata }, autoFocus: false,
  //         disableClose: true
  //       })
  //       updateactionRef.afterClosed().subscribe((dat) => {
  //         if (dat) {
  //           this.getHistoryInfo()
  //         }
  //       })
  //     })
  //     .catch((err) => {
  //       this.assigUserSpinnerState = false;
  //     })
  //   // } else {
  //   //   //No alert selected Toaster
  //   //   this.alertvarservice.createtoastmsg({
  //   //     type: "warning",
  //   //     "text": "No alert selected"
  //   //   })
  //   // }
  // }


  openUpdateActionNew(selectedstatus: any) {
    // if (selectedAlert.length) {
    this.assigUserSpinnerState = true;
    this.getUserList()
      .then((userlist) => {
        this.assigUserSpinnerState = false;
        const updateactionRef = this.matdialog.open(ExploreAlertActionPanelComponent, {
          width: "35vw", data: { userlist, selectedstatus, "alertActionMetadata": this.alertActionMetadata,"totalCount":this.alertvarservice.SelectAllAlerts?(this.alertvarservice.AlertEventsCount - this.excludedAlerts()):this.get_alerts_events_len('selectedAlerts') },
          autoFocus: false,
          disableClose: true
        })
        updateactionRef.afterClosed().subscribe((dat) => {
          if (dat) {
            this.getHistoryInfo()
          }
        })
      })
      .catch((err) => {
        this.assigUserSpinnerState = false;
      })
    // } else {
    //   //No alert selected Toaster
    //   this.alertvarservice.createtoastmsg({
    //     type: "warning",
    //     "text": "No alert selected"
    //   })
    // }
  }

  openUpdateAction(selectedAlert: any[]) {
    // if (selectedAlert.length) {
    const updateactionRef = this.matdialog.open(UpdateActionComponent, {
      width: "41vw", height: "50vh", data: { selectedAlert, "alertActionMetadata": this.alertActionMetadata }, autoFocus: false,
      disableClose: true
    })
    updateactionRef.afterClosed().subscribe((dat) => {
      if (dat) {
        this.getHistoryInfo()
        this.clearAllSelectedAlerts()
      }
    })
    // } else {
    //   //No alert selected Toaster
    //   this.alertvarservice.createtoastmsg({
    //     type: "warning",
    //     "text": "No alert selected"
    //   })
    // }
  }

  updateActionSelectedAlert() {
    if (!this.isAction) {
      this.openUpdateAction([this.alertvarservice.selectedEventPagenumber - 1]);
    }
  }

  back() {
    this.alertvarservice.alertEventsListView = true;
  }

  paginationTable_click(mode: string, direction: number) {
    // //console.log(this.isAction)
    // //console.log(this.alertvarservice.alertactionmanagement)
    if (!this.isAction) {
      if (mode == 'Alerts') {

        if (direction == 1) {
          if (this.alertvarservice.eventspagelength > this.alertvarservice.eventspagenumber) {
            this.alertvarservice.eventspagenumber += 1;
            this.fetchpaginationEvents();
            this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
          }
        } else if (direction == -1) {
          if (this.alertvarservice.eventspagenumber > 1) {
            this.alertvarservice.eventspagenumber -= 1;
            this.fetchpaginationEvents();
            this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
          }
        }
      }
      else {
        if (direction == 1) {
          if (this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength > this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber) {
            this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber += 1;
            // this.sliceWorkFlowAlerts()
            this.searchAndPaginationWithSelectedAlerts('pagination')
          }
        } else if (direction == -1) {
          if (this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber > 1) {
            this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber -= 1;
            // this.sliceWorkFlowAlerts()
            this.searchAndPaginationWithSelectedAlerts('pagination')
          }
        }

      }
    }

  }

  fetchpaginationEvents() {
    const reqobj = this.alertvarservice.build_eventReqobj();
    reqobj.pagination = false;
    if (this.alertvarservice.alertSearchInfo.alertSearchState) {
      reqobj.search = 'value'
      reqobj.status = this.alertvarservice.alertSearchInfo.status
      reqobj.state = this.alertvarservice.alertSearchInfo.statusreason
    }

    this.setupEvents(reqobj);
  }

  fetchPagechangeEvents() {
    this.alertvarservice.resetEventsPagination();
    this.alertvarservice.alertEventsListView = true;
    const reqobj = this.alertvarservice.build_eventReqobj();
    if (this.alertvarservice.alertSearchInfo.alertSearchState) {
      reqobj.search = 'value'
      reqobj.status = this.alertvarservice.alertSearchInfo.status
      reqobj.state = this.alertvarservice.alertSearchInfo.statusreason
    }
    this.setupEvents(reqobj);
  }

  alertSummaryresetclicked() {
    this.alertvarservice.resetEventsPagination();
    this.alertvarservice.eventlist.length = 0;
    // this.alertvarservice.isVisibleEvents = false;
    this.alertvarservice.alertEventsListView = true;
    this.alertvarservice.nodesummarydata.series.length = 0;
    this.alertvarservice.eventWorkFlowInfo.selectedAlerts = {}
    this.alertvarservice.SelectAllAlerts = false;
    this.alertvarservice.eventsSelectAll.setValue(false);
    this.alertvarservice.eventWorkFlowInfo.selectedAlerts = {}
    this.alertvarservice.filteredNodesumarryArray = []    // this.alertvarservice.summaryPanel = FactsheetSummaryPanel.closed;
    // this.alertvarservice.eventsPanel = FactsheetSummaryPanel.closed;
    // this.alertvarservice.isEventsTable = false;
    this.alertvarservice.AlertEventsCount = 0
    this.getOverview();
  }

  alertOverviewReset() {

  }

  advancedFilterChangeHandle() {
    this.alertSummaryresetclicked();
    this.alertOverviewReset();
    //new graph data fetch
  }

  nodeSelected(event) {
    if (this.alertvarservice.lastClickedNode.id != this.alertvarservice.previousselectedNode) {
      this.alertvarservice.advancefilter_pannelexpanded = false;
      // this.alertvarservice.alertEventSelectedIndex = 0;
      this.alertvarservice.currentIndex = 0;
      // this.alertvarservice.alertEventSelectedIndex = 0;
      this.alertvarservice.nodeinfo = event[1];
      this.restartAlertWorkflows()
      this.alertvarservice.alertEventsSearch.setValue('', { emitEvent: false })
      // this.showEvents()
      this.showEventsTable();
      this.alertvarservice.changeCanvas();
      // this.alertvarservice.collapseSummaryPanel()
      this.showDetail()
      // if (event[0] == 1) {//node is selected from AfterViewInit
      //   // show overview

      // }
      // else {//user selected node
      //   // show list
      //   this.alertvarservice.currentIndex = 1
      // }
      // if (event[1].bubbles.length) {
      //   this.alertvarservice.alertEventSelectedIndex = 1
      // }
      // else {
      //   this.alertvarservice.alertEventSelectedIndex = 0

      // }
    }

  }

  paginationViewTable_click(direction: number) {

    if (!this.isAction) {
      if (direction == 1) {
        if (this.alertvarservice.selectedEventPagelenght > this.alertvarservice.selectedEventPagenumber) {
          this.alertvarservice.selectedEventPagenumber += 1;
        }
      } else if (direction == -1) {
        if (this.alertvarservice.selectedEventPagenumber > 1) {
          this.alertvarservice.selectedEventPagenumber -= 1;
        }
      }
    }
  }

  cancel_events() {
    this.alertvarservice.handleprovideeventsdataerror.seterror(true, this.alertvarservice.alertsheetmeta.noDatamsg[2]);
    this.alertService.provideeventsdata.cancelRequest();
  }

  cancel_summary() {
    this.alertvarservice.handleDetaildataerror.seterror(true, this.alertvarservice.alertsheetmeta.noDatamsg[2]);
    this.alertService.provideDetaildata.cancelRequest();
  }

  cancel_overview() {
    this.alertvarservice.handleOverviewdataerror.seterror(true, this.alertvarservice.alertsheetmeta.noDatamsg[2]);
    this.alertService.provideoverviewdata.cancelRequest();
  }
  //additional filters functions

  //whenever user change eventfield input value
  eventChange(setindex: number, lineindex: number) {
    this.alertvarservice.conditionvalue(setindex, lineindex).clear();
    this.alertvarservice.operatorField(setindex, lineindex).reset([
      "=",
      [
        0,
        1,
        2,
        3
      ]
    ]);
  }


  moreChips_click(template: ElementRef<any>, origin: ElementRef<any>) {
    let config = {
      data: {
        "template": template,
      }
    }
    this.alertvarservice.overLayRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }

  //condition value input
  onKeydown(enterevent, setindex: number, lineindex: number, blurevent: string, field: any) {
    if ((enterevent.key == "Enter" || blurevent) && field) {
      let input = this.alertvarservice.conditionInputField(setindex, lineindex);
      let inputval = input.value;
      if (field.type == 'number') {
        inputval = Number(inputval);
      }
      if (inputval) {
        this.alertvarservice.conditionvalue(setindex, lineindex).push(new FormControl(inputval))
        input.reset()
      }
    }
  }

  // resetAdditionalFilter() {
  //   this.alertvarservice.conditonEventField.reset('');
  //   this.alertvarservice.operator.reset([
  //     "=",
  //     [
  //       0,
  //       1,
  //       2,
  //       3
  //     ]
  //   ]);
  //   this.alertvarservice.values.length = 0;
  // }

  addToFilters(fieldDetails: any) {
    if (!this.isAction) {
      const setindex = this.alertvarservice.filtercondition.length - 1;
      const lineindex = this.alertvarservice.conditionlines(this.alertvarservice.filtercondition.length - 1).controls.length - 1;
      let eventcontrol = this.alertvarservice.conditioneventField(setindex, lineindex);
      if (eventcontrol.value) {
        if (this.alertvarservice.conditionlines(this.alertvarservice.filtercondition.length - 1).controls.length < 5) {
          const controls = this.alertvarservice.addCondition();
          controls.patchValue({
            eventField: {
              field: fieldDetails.field,
              type: fieldDetails.type,
              display_type: fieldDetails.display_type
            }
          })
          this.alertvarservice.conditionlines(this.alertvarservice.filtercondition.length - 1).push(controls);
        }
      } else {
        this.eventChange(setindex, lineindex);
        eventcontrol.setValue({
          field: fieldDetails.field,
          type: fieldDetails.type,
          display_type: fieldDetails.display_type
        })
      }
    }
  };
  ngOnDestroy(): void {
    // //console.log("factsheet comp destroyed")
    this.$destroy.next(true);
    this.$destroy.unsubscribe()
    //reset relation chart variables.
    // console.log("Fact sheet Opened =---->",this.alertvarservice.factSheetOpened)
    if (this.alertService.checklogged()) {
      // console.log("Logged in")
      // if (this.alertvarservice.factSheetOpened) {
        // console.log("Fact sheet destroyed")
        // this.alertService.factsheetcomponentDestroyed.next(0);
      // }
    }
  }

  moveplatformlist(direction: number) {
    this.platform_list.nativeElement.scrollTo({ left: direction * (this.platform_list.nativeElement.scrollLeft + 100), behavior: 'smooth' });
  }

  setLimitFilter(filtername) {
    var filterindex = this.alertvarservice.selectedInstantFilter['limit'].findIndex((obj) => obj.label == filtername)
    var currentFilter = this.alertvarservice.selectedInstantFilter['limit'][filterindex];
    this.alertvarservice.selectedInstantFilter['limit'][filterindex].isSelected = true;

    var result = this.alertvarservice.filters.findIndex(checkObj)
    if (result >= 0) {
      this.alertvarservice.filters.splice(result, 1)
    }
    function checkObj(obj) {
      return obj.category == 'limit'
    }
    this.alertvarservice.filters.push(this.alertvarservice.selectedInstantFilter['limit'][filterindex]);

    // //console.log(this.alertvarservice.filters)


  }

  selectInstantFilter(filtername, index, isEnable) {
    if (isEnable) {
      var currentFilter = this.alertvarservice.selectedInstantFilter[filtername][index]
      this.alertvarservice.selectedInstantFilter[filtername][index].isSelected = !this.alertvarservice.selectedInstantFilter[filtername][index].isSelected
      // //console.log(this.alertvarservice.selectedInstantFilter[filtername][index])
      if (this.alertvarservice.selectedInstantFilter[filtername][index].isSelected) {
        this.alertvarservice.filters.push(this.alertvarservice.selectedInstantFilter[filtername][index])
        this.alertvarservice.filterslist.push(this.alertvarservice.selectedInstantFilter[filtername][index])
      }
      else {
        var result = this.alertvarservice.filters.findIndex(checkObj)
        if (result >= 0) {
          this.alertvarservice.filters.splice(result, 1)
        }
        var filterlist = this.alertvarservice.filterslist.findIndex(checkObj)
        if (filterlist >= 0) {
          this.alertvarservice.filterslist.splice(filterlist, 1)
        }
      }
      function checkObj(obj) {
        return obj.label == currentFilter.label
      }

      if (this.alertvarservice.mutual_exclusive_filters.hasOwnProperty(filtername)) {
        this.alertvarservice.mutual_exclusive_filters[filtername][currentFilter.label].isSelected = !this.alertvarservice.mutual_exclusive_filters[filtername][currentFilter.label].isSelected
      }
    }

//console.log("Filter list =---->", this.alertvarservice.filterslist)
    // console.log(this.alertvarservice.filterpannelexpanded)
  }

  removeChip_click(filtername: string, index: number, category: string) {
    this.alertvarservice.filterslist.splice(index, 1);
    var currentFilter = this.alertvarservice.selectedInstantFilter[category];
    var result = currentFilter.findIndex(checkObj)
    if (result >= 0) {
      this.alertvarservice.selectedInstantFilter[category][result].isSelected = false;
    }
    var filter_result = this.alertvarservice.filters.findIndex(checkObj)
    if (filter_result >= 0) {
      this.alertvarservice.filters.splice(filter_result, 1)
    }
    function checkObj(obj) {
      return obj.label == filtername
    }

    if (this.alertvarservice.mutual_exclusive_filters.hasOwnProperty(category)) {
      this.alertvarservice.mutual_exclusive_filters[category][filtername].isSelected = !this.alertvarservice.mutual_exclusive_filters[category][filtername].isSelected
    }

    if (!this.alertvarservice.filterslist.length) {
      this.alertvarservice.overLayRef?.close();
    }
  }

  //filters functions
  expand_collapse_filter(filtername: string) {
    this.alertvarservice.filterpannelexpanded[filtername] = !this.alertvarservice.filterpannelexpanded[filtername]
//console.log("Expanded pannels",this.alertvarservice.filterpannelexpanded)
  }

  open_filterslist(template: any, origin: any) {
    let config = {
      data: {
        "template": template,
      },
      width: '28vw'
    }
    this.alertvarservice.overLayRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }

  checkMutualExclusive() {
    let filteredList = [...this.alertvarservice.filters]
    for (let category in this.alertvarservice.mutual_exclusive_filters) {
      let selected_filters = Object.values(this.alertvarservice.mutual_exclusive_filters[category]).every((obj) => obj['isSelected'] == true)
      if (selected_filters) {
        filteredList = filteredList.filter((obj) => obj.category != category)
      }
    }
    return filteredList
  }

  applyInstantFilter() {
    if (!this.isAction) {
      if (this.alertvarservice.filtercondition.valid) {
        this.alertvarservice.resetPreviousNodeSelection()
        this.errorState = false;
        this.setLimitFilter(this.alertvarservice.limitfilter.value);
        const filteredList = this.checkMutualExclusive()
        this.alertvarservice.nodeinfo.instantFilter = filteredList
        const filterdisplay = [...this.alertvarservice.filters]
        this.alertvarservice.nodeinfo.instantFilterDisplay = filterdisplay
        const advanceFilter = this.processFilters();
        this.alertvarservice.nodeinfo = { ...this.alertvarservice.nodeinfo, ...advanceFilter }
        // this.validateAdvanceFilter()
        if (advanceFilter.advanceFilter.length) {
          this.alertvarservice.nodeinfo.advanceFilterDisplay = this.alertvarservice.filtercondition.value
        } else {
          this.alertvarservice.nodeinfo.advanceFilterDisplay.length = 0;
        }
        this.alertvarservice.nodeInstantFilter.next()
      } else {
        this.errorState = true;
      }

    }
  }

  // getLegendHasAlertCount() {
  //   var alertCountObject = { has_alerts: 0, has_no_alerts: 0 }
  //   this.alertvarservice.nodesummarydata.series.forEach(element => {
  //     if (element.display.count > 0) {
  //       alertCountObject["has_alerts"] += 1
  //     }
  //     else {
  //       alertCountObject["has_no_alerts"] += 1
  //     }
  //   });
  //   this.alertvarservice.alertSummaryCountDetails = alertCountObject
  // }

  getNodeChartData() {
    var axisData = []
    var seriesData = []
    // var alertCountObject = { has_alerts: 0, has_no_alerts: 0 }
    if (this.alertvarservice.lastClickedNode) {
      this.alertvarservice.nodesummarydata.series.forEach(element => {
        seriesData.push(element.display.count)
        axisData.push(element.display.disp)
        // if (element.display.count > 0) {
        //   alertCountObject["has_alerts"] += 1
        // }
        // else {
        //   alertCountObject["has_no_alerts"] += 1
        // }
      });
      // this.getLegendHasAlertCount();


    }
    return { "axisData": axisData, "seriesData": seriesData }
  }
  load_chart() {
    var Nodedata = this.getNodeChartData()
    const chartDom = document.getElementById("nodeChart")
    if (chartDom) {
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption({
        xAxis: {
          data: Nodedata.axisData
        },
        series: {
          data: Nodedata.seriesData
        }
      })
    } else {
      // console.error('Chart DOM element not found.');
    }

  }
  openAddNotes_new(selectedAlert: any[]) {
    if (selectedAlert.length) {
      // const notesdialogRef = this.matdialog.open(AddNotesComponent, {
      //   width: "30vw", height: "50vh", data: { selectedAlert }, autoFocus: false,
      //   disableClose: true
      // })
      let origin = document.getElementById("add-notes")
      let config = {
        data: {
          "template": this.addNotesTemplate,
        }
      };
      this.addNotesRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);

    } else {
      this.alertvarservice.createtoastmsg({
        type: "warning",
        "text": "No alert selected"
      })
    }

  }

  search_click(event) {
    if (event.key == "Enter") {
      if (this.alertvarservice.alertEventsSearch.value == '') {
        this.alertvarservice.alertSearchInfo.alertSearchState = false
      }
      else {
        this.alertvarservice.alertSearchInfo.alertSearchState = true
        let searchValue = this.alertvarservice.alertEventsSearch.value
        this.alertvarservice.alertSearchInfo.searchval = searchValue
        let alertStatus = []
        let alertstates = []
        Object.keys(this.alertActionMetadata.action_disp).forEach((key) => {
          if (this.alertActionMetadata.action_disp[key]['status_val'].toLowerCase().includes(searchValue.toLowerCase()) ||
            this.alertActionMetadata.action_disp[key]['state_val'].toLowerCase().includes(searchValue.toLowerCase()) ||
            this.alertActionMetadata.action_disp[key]['status_disp'].toLowerCase().includes(searchValue.toLowerCase()) ||
            this.alertActionMetadata.action_disp[key]['state_disp'].toLowerCase().includes(searchValue.toLowerCase())

          ) {
            alertStatus.push(key)
          }
        })

        for (let status_disp in this.alertActionMetadata.actions) {
          for (let state in this.alertActionMetadata.actions[status_disp]['state_action']) {
            for (let alertstateid in this.alertActionMetadata.actions[status_disp]['state_action'][state]['reason']) {

              let reason = this.alertActionMetadata.actions[status_disp]['state_action'][state]['reason'][alertstateid]
              if (reason.toLowerCase().includes(searchValue.toLowerCase())) {
                alertstates.push(alertstateid)
                alertStatus.push(this.alertActionMetadata.actions[status_disp]['state_action'][state]['id'])
              }
            }

          }
        }
        this.alertvarservice.alertSearchInfo.status = alertStatus
        this.alertvarservice.alertSearchInfo.statusreason = alertstates
        if (this.alertvarservice.alertSearchInfo.status.length > 0 || this.alertvarservice.alertSearchInfo.statusreason.length > 0) {
          // this.showEventsTable()
          this.alertvarservice.alertSearchInfo.invalidSearchKeyStatus = false
          this.alertvarservice.eventspagenumber = 1
          this.alertvarservice.resetEventsPagination();
          let reqobj = this.alertvarservice.build_eventReqobj()
          reqobj['search'] = 'value'
          reqobj['status'] = this.alertvarservice.alertSearchInfo.status
          reqobj['state'] = this.alertvarservice.alertSearchInfo.statusreason

          // this.alertvarservice.eventsPanel = FactsheetEventsPanel.collapse;
          // this.alertvarservice.collapseEventsPanel()
          // this.alertvarservice.isVisibleEvents = true;
          // this.alertvarservice.isEventsTable = false;
          this.alertvarservice.alertEventsListView = true;
          this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
          this.setupEvents(reqobj);
        }
        else {
          this.alertvarservice.alertSearchInfo.invalidSearchKeyStatus = true
        }
      }

    }
  }




  // additional filters

  expand_collapse_advancefilter() {
    this.alertvarservice.advancefilter_pannelexpanded = !this.alertvarservice.advancefilter_pannelexpanded;
  }


  addAnotherSet() {
    this.alertvarservice.addconditionSet();
    /* setTimeout(()=>{
        if(this.addConditionsethandle && this.addConditionsethandle.toArray().length){
          this.addConditionlinehandle.last.nativeElement
          .scrollIntoView({behavior: "smooth",block: "end",inline:"end"});
        }
      },1)*/
  }
  removeCondition_click(setindex: number, lineindex: number) {
    if (this.alertvarservice.conditionlines(setindex).length == 1) {
      if (!setindex) {
        this.alertvarservice.conditionlines(setindex).removeAt(lineindex);
        this.alertvarservice.addFilterCondition(setindex);
      }
      else if (setindex) {
        if (setindex == this.alertvarservice.filtercondition.length - 1) {
          this.alertvarservice.filtercondition.controls[setindex - 1].get('operationConditionset').setValue("");
        }
        this.alertvarservice.filtercondition.removeAt(setindex);
      }
    } else if (this.alertvarservice.conditionlines(setindex).length > 1) {
      this.alertvarservice.conditionlines(setindex).removeAt(lineindex);
    }
  }

  processFilters() {
    const filterconditionvalue = this.alertvarservice.filtercondition.getRawValue();
    const advanceFilter = [];
    const set_operators = [];
    for (let i = 0; i < filterconditionvalue.length; i++) {
      const setobj = {};
      const conditionarr = this.processSet(filterconditionvalue[i]);
      if (conditionarr.length) {
        if (filterconditionvalue[i].operationconditionLine) {
          setobj["cdn_operator"] = "AND";
        } else {
          setobj["cdn_operator"] = "OR";
        }
        setobj["conditions"] = conditionarr;
        advanceFilter.push(setobj);
        if (filterconditionvalue[i].operationConditionset) {
          set_operators.push(filterconditionvalue[i].operationConditionset);
        }
      }
    }

    return {
      advanceFilter,
      set_operators
    }
  }
  processSet(filterconditionset: any) {
    const conditionarr = [];
    for (let j = 0; j < filterconditionset.conditionLines.length; j++) {
      if (filterconditionset.conditionLines[j].eventField) {
        const cond_obj = {};
        cond_obj["field"] = filterconditionset.conditionLines[j].eventField.field;
        cond_obj["type"] = filterconditionset.conditionLines[j].eventField.type;
        cond_obj["operator"] = filterconditionset.conditionLines[j].operator[0];
        if (filterconditionset.conditionLines[j].operator[0] == "=" || filterconditionset.conditionLines[j].operator[0] == "!=") {
          cond_obj["value"] = filterconditionset.conditionLines[j].conditionValue[0];
        } else {
          cond_obj["value"] = filterconditionset.conditionLines[j].conditionValue;
          // cond_obj["value"] = "";

        }
        conditionarr.push(cond_obj);
      }
    }
    return conditionarr;
  }
  setAdditionalFilters(additionalFilterArray, filtercondition) {
    filtercondition.map((element, idx) => {
      const conditionset = new FormGroup({
        operationconditionLine: new FormControl(element.operationconditionLine),
        conditionLines: new FormArray(
          element.conditionLines.map((item, i) => {
            return new FormGroup({
              eventField: new FormControl(element.conditionLines[i].eventField),
              operator: new FormControl(element.conditionLines[i].operator),
              conditionValue: new FormArray(element.conditionLines[i].conditionValue.map((val, j) => {
                return new FormControl(element.conditionLines[i].conditionValue[j])
              })),
              conditionInput: new FormControl(''),
            }, {
              validators: [ValueValidator()]
            })
          })
        ),
        operationConditionset: new FormControl(element.operationConditionset)
      })
      additionalFilterArray.push(conditionset)

    })
  }

  clearInPageClick() {
    this.selectAllAlertsInPage(false)
    this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
  }



  sliceWorkFlowAlerts() {
    // this.paginationDataWorkFlowAlert
    let paginationData = []
    if (this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber == 1) {
      paginationData = Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
    }
    else {
      paginationData = Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).slice((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber - 1) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value, ((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value))
    }
    let selectedAllCheckBoxState = true
    paginationData.forEach((key: string) => {
      if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key].isSelected) {
        selectedAllCheckBoxState = false
      }
    })
    this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(selectedAllCheckBoxState, { emitEvent: false })
    this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = paginationData
    this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert.sort((a, b) => parseInt(b) - parseInt(a));
    // slice:(alertvarservice.alertWorkFlowInfo.selectedeventspagenumber-1)*alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value :(alertvarservice.alertWorkFlowInfo.selectedeventspagenumber)*alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value
  }

  searchAndPaginationWithSelectedAlerts(mode: string) {
    let searchVal = this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSearch.value
    let selected_events_keys = []

    Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).map((key) => {
      let obj = this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key]
      if (this.alertActionMetadata.action_disp[obj["status"]]['status_val'].toLowerCase().includes(searchVal.toLowerCase())
        || this.alertActionMetadata.action_disp[obj["status"]]['state_val'].toLowerCase().includes(searchVal.toLowerCase()) ||
        this.alertActionMetadata.action_disp[obj["status"]]['status_disp'].toLowerCase().includes(searchVal.toLowerCase())
        || this.alertActionMetadata.action_disp[obj["status"]]['state_disp'].toLowerCase().includes(searchVal.toLowerCase())

      ) {
        // || obj["alertstate"].toLowerCase().includes(searchVal.toLowerCase())
        selected_events_keys.push(key)
      }

    })
    Object.keys(this.alertvarservice.alertWorkFlowInfo.selectedAlerts).map((key) => {
      let obj = this.alertvarservice.alertWorkFlowInfo.selectedAlerts[key]
      for (let status_disp in this.alertActionMetadata.actions) {
        for (let state in this.alertActionMetadata.actions[status_disp]['state_action']) {
          if (this.alertActionMetadata.actions[status_disp]['state_action'][state]['id'] == obj['status'].toString()) {
            // for(let alertstateid in this.alertActionMetadata.actions[status_disp]['state_action'][state]['reason']){

            let reason = this.alertActionMetadata.actions[status_disp]['state_action'][state]['reason'][obj['alertstate']]
            if (reason.toLowerCase().includes(searchVal.toLowerCase()) && selected_events_keys.indexOf(key) == -1) {
              selected_events_keys.push(key)
            }
            // }
          }

        }
      }
    })

    selected_events_keys.sort((a, b) => parseInt(b) - parseInt(a));

    if (searchVal != '') {
      if (mode == 'search') {
        this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(selected_events_keys.length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
        this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
        selected_events_keys = selected_events_keys.slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
        this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      }
      else if (mode == 'pagination') {
        if (this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber == 1) {
          selected_events_keys = selected_events_keys.slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
        }
        else {
          selected_events_keys = selected_events_keys.slice((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber - 1) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value, ((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value))
        }

        this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      }
      else if (mode == 'itemPerPage') {
        this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
        this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(selected_events_keys.length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
        selected_events_keys = selected_events_keys.slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
        this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      }
    }
    else if (mode == 'pagination') {

      if (this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber == 1) {
        selected_events_keys = selected_events_keys.slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
      }
      else {
        selected_events_keys = selected_events_keys.slice((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber - 1) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value, ((this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber) * this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value))
      }

      this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
      let isAnyFalse = true
      for (let elementIndex in this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert) {
        let elementval = this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert[elementIndex]
        if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[elementval].isSelected) {
          isAnyFalse = false
          break
        }
      }
      if (isAnyFalse) {
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
      }
      else {
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
      }
    }
    else {
      this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
      this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = this.alertvarservice.calculatepagelength(selected_events_keys.length, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
      selected_events_keys = selected_events_keys.slice(0, this.alertvarservice.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
      this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = selected_events_keys
    }


  }

  openEntityFieldsMenu(template: any, origin: any, event: any) {
    event.stopPropagation()
    let config = {
      data: {
        "template": template,
      },
      // height: "20vh",
      width: "15vw",
    }
    this.entityFieldsRef = this.cdkoverlayDialog.openList(config, TemplateDropdownComponent, origin);
  }

  changeViewFormat(key: string, val) {
    if (key == 'Episodes Without Alerts / Total Episodes') {
      return this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[1]['Episodes in Time Range'] - this.alertvarservice.rootNodeEpisodesCount) + " of " + this.alertvarservice.numberWithCommas(this.alertvarservice.overviewDetails[1]['Episodes in Time Range']) + " (" + (((this.alertvarservice.overviewDetails[1]['Episodes in Time Range'] - this.alertvarservice.rootNodeEpisodesCount) / this.alertvarservice.overviewDetails[1]['Episodes in Time Range']) * 100).toFixed(2).toString() + "%)"
    }
    else if (key == 'Avg. Alerts per Episode') {
      return this.alertvarservice.numberWithCommas(val.toFixed(0))
    }
    else if (key == 'Episode Insight Table') {
      return this.alertvarservice.alertInsightTable
    }
    else if (key == 'Episode Insight Table') {
      return this.alertvarservice.alertInsightTable
    }
    else if (key == 'Field Coverage') {
      // //console.log('Field Coverage==================',this.alertvarservice.rootNodeEntityFields,this.alertvarservice.alertNonEntityFields)
      return this.alertvarservice.numberWithCommas(this.alertvarservice.rootNodeEntityFields.length + this.alertvarservice.alertNonEntityFields.length)
    }
    else {
      return val
    }
  }

  openTimePanel(orgin, key: string) {
    if (key == "Start Time" || key == "End Time" || key == 'Episode Length') {
      this.alertvarservice.openAdvancedFilter(orgin, 2, this.isAction)
    }
    else if (key == "Duration") {
      this.alertvarservice.openAdvancedFilter(orgin, 1, this.isAction)
    }
    else {
      // //console.log("no click")
    }

  }




  SelectAllAlerts() {
    if (!(this.isAction || !this.alertvarservice.AlertEventsCount)){
      this.alertvarservice.SelectAllAlerts = true
      this.updateSelectedAlertEvents(this.alertvarservice.SelectAllAlerts)
      this.alertvarservice.eventsSelectAll.patchValue(true)
    }
  }
  clearAllSelectedAlerts() {
    // this.alertvarservice.SelectAllAlerts = false
    if (!(this.isAction || !this.alertvarservice.AlertEventsCount)){
      this.alertvarservice.clearAllPageClick()
      this.alertvarservice.eventWorkFlowInfo.selectedAlerts = {}
    }

  }




  getRangeGroup(num) {
    if (num <= 0) return 0; // handle invalid or zero input
    return Math.ceil(num / 100);
  }
  buildAlertKey(alertObject) {
    // return alertObject['alerttime'].toString() + alertObject['seq_no'].toString()
    return alertObject
  }
  isAlertInCurrentPageSlected(pagenumber, eventNumber, itemsper_page, eventRefKey) {
    let batch = this.getRangeGroup((itemsper_page * pagenumber) - itemsper_page + eventNumber + 1)
    //console.log("isAlertInCurrentPageSlected", batch, eventRefKey)
    if (this.alertvarservice.eventWorkFlowInfo.selectedAlerts.hasOwnProperty(batch) && this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch].hasOwnProperty(eventRefKey) && this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][eventRefKey]["selected"]) {
      return true
    }
    return false
  }

  SelectUntouchedAlerts() {
    for (let index = 0; index < this.alertvarservice.eventsItemperpage.value; index++) {
      let batch = this.getRangeGroup((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)
      let eventRefKey = (this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1

      // if (!(batch in this.alertvarservice.eventWorkFlowInfo.selectedAlerts)) {
      if (batch in this.alertvarservice.eventWorkFlowInfo.selectedAlerts) {
        if (!(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch].hasOwnProperty(eventRefKey))) {
          // this.alertvarservice.updateSelectedEventAlerts(this.alertvarservice.AlertEvents[eventRefKey], JSON.stringify(eventRefKey), index)
          this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][eventRefKey] = { alerttime: this.alertvarservice.AlertEvents[eventRefKey]['alerttime'], seq_no: this.alertvarservice.AlertEvents[eventRefKey]['seq_no'], selected: true }
        }
      }
      else {
        this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch] = {}
      }
      // }
    }
  }
  selectAllAlertsInPage(status: boolean) {
    if (status) {
      this.alertvarservice.eventlist.forEach((val, index) => {
        // let alertKey = this.buildAlertKey(this.alertvarservice.eventlist[index])
        let alertKey = this.buildAlertKey((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)
        let batch = this.getRangeGroup((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)
        let tempValue = JSON.parse(JSON.stringify(val))
        let alertBatcValue = { alerttime: tempValue['alerttime'], seq_no: tempValue['seq_no'], selected: status }
        if (batch in this.alertvarservice.eventWorkFlowInfo.selectedAlerts) {
          this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertKey] = alertBatcValue
        }
        else {
          let repobj = {}
          repobj[alertKey] = alertBatcValue
          // //console.log("updateSelectedAlertEvents", repobj)
          this.alertvarservice.eventWorkFlowInfo.selectedAlerts = { ...this.alertvarservice.eventWorkFlowInfo.selectedAlerts, [batch]: repobj }
        }
      });
    }
    else {
      this.alertvarservice.eventlist.forEach((val, index) => {
        // let alertKey = this.buildAlertKey(this.alertvarservice.eventlist[index])
        let alertKey = this.buildAlertKey((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)

        let batch = this.getRangeGroup((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + index + 1)
        let tempValue = JSON.parse(JSON.stringify(val))
        let alertBatcValue = { alerttime: tempValue['alerttime'], seq_no: tempValue['seq_no'], selected: status }
        if (batch in this.alertvarservice.eventWorkFlowInfo.selectedAlerts) {
          this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertKey] = alertBatcValue

          // delete this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertKey]
        }
        else {
          // let repobj = {}
          // repobj[alertKey] = alertBatcValue
          // // //console.log("updateSelectedAlertEvents", repobj)
          // this.alertvarservice.eventWorkFlowInfo.selectedAlerts = { ...this.alertvarservice.eventWorkFlowInfo.selectedAlerts, [batch]: repobj }
        }
      });

    }
  }


  SelectAllInPage() {
    if (!(this.isAction || !this.alertvarservice.AlertEventsCount)){
      this.alertvarservice.eventsSelectAll.setValue(!this.alertvarservice.eventsSelectAll.value, { emitEvent: true })
    }
  }
  excludedAlerts() {
    let excludeAlert = 0
    Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
      Object.keys(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
        if (!this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertkey]["selected"])
          // excludeAlert.push(this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          excludeAlert += 1
      })
    })
    return excludeAlert
  }
}
